import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import CustomNavbar from '../components/Navbar';
import { Form, Input, Button, notification, Card, Typography, Space } from 'antd';
import { LockOutlined, SafetyOutlined, ArrowRightOutlined } from '@ant-design/icons';
import api from '../api/axios';


const { Title, Text } = Typography;

const ChangePassword = () => {
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();

	const onFinish = async (values) => {
		setLoading(true);
		try {
			const response = await api.post('/change-password', values);
			if (response.status === 200 && response.data.status === 'success') {
				notification.success({
					message: 'Password Changed Successfully',
					description: 'Your password has been updated successfully.',
				});
				form.resetFields();
			} else {
				notification.error({
					message: 'Password Change Failed',
					description: response.data.message || 'Something went wrong. Please try again.',
				});
			}
		} catch (error) {
			notification.error({
				message: 'Password Change Failed',
				description: error.response?.data?.message || 'An error occurred while changing your password.',
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div style={{
			fontFamily: 'Calibri, sans-serif',
			minHeight: '100vh',
			background: '#fff'
		}}>
			<Helmet><title>Change Password | Oottan</title></Helmet>
			<CustomNavbar />
			<div style={{
				maxWidth: '500px',
				margin: '80px auto 40px',
				padding: '0 20px'
			}}>
				<Card
					style={{
						borderRadius: '12px',
						boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
					}}
				>
					<div style={{ textAlign: 'center', marginBottom: '32px' }}>
						<Space direction="vertical" size="small">
							<SafetyOutlined style={{
								fontSize: '48px',
								color: '#AD1457',
								marginBottom: '16px'
							}} />
							<Title level={3} style={{
								margin: 0,
								color: '#333',
								fontWeight: 600
							}}>
								Change Password
							</Title>
							<Text type="secondary" style={{ fontSize: '14px' }}>
								Update your account password for enhanced security
							</Text>
						</Space>
					</div>

					<Form
						form={form}
						name="change_password"
						onFinish={onFinish}
						layout="vertical"
						size="large"
					>
						<Form.Item
							name="current_password"
							label="Current Password"
							rules={[{ required: true, message: 'Please input your current password!' }]}
						>
							<Input.Password
								prefix={<LockOutlined style={{ color: '#AD1457' }} />}
								placeholder="Enter current password"
								style={{ borderRadius: '8px' }}
							/>
						</Form.Item>

						<Form.Item
							name="new_password"
							label="New Password"
							rules={[
								{ required: true, message: 'Please input your new password!' },
								{ min: 8, message: 'Password must be at least 8 characters!' }
							]}
						>
							<Input.Password
								prefix={<LockOutlined style={{ color: '#AD1457' }} />}
								placeholder="Enter new password"
								style={{ borderRadius: '8px' }}
							/>
						</Form.Item>

						<Form.Item
							name="new_password_confirmation"
							label="Confirm New Password"
							dependencies={['new_password']}
							hasFeedback
							rules={[
								{ required: true, message: 'Please confirm your new password!' },
								({ getFieldValue }) => ({
									validator(_, value) {
										if (!value || getFieldValue('new_password') === value) {
											return Promise.resolve();
										}
										return Promise.reject(new Error('The two passwords do not match!'));
									},
								}),
							]}
						>
							<Input.Password
								prefix={<LockOutlined style={{ color: '#AD1457' }} />}
								placeholder="Confirm new password"
								style={{ borderRadius: '8px' }}
							/>
						</Form.Item>

						<Form.Item>
							<Button
								type="primary"
								htmlType="submit"
								loading={loading}
								block
								style={{
									height: '48px',
									borderRadius: '8px',
									fontSize: '16px',
									fontWeight: 500,
									backgroundColor: '#AD1457',
									borderColor: '#AD1457',
									boxShadow: '0 4px 12px rgba(93, 63, 211, 0.2)'
								}}
							>
								Update Password <ArrowRightOutlined />
							</Button>
						</Form.Item>
					</Form>
				</Card>
			</div>
		</div>
	);
};

export default ChangePassword;